<!-- eslint-disable import/no-cycle -->
@if (identifyIssueBy === 'service') {
  <h3 class="mt-2 font-lato text-xs font-bold uppercase">Which service?</h3>

  <mat-form-field>
    <mat-label>Please select a service</mat-label>
    <input
      type="text"
      placeholder="Please select a service"
      aria-label="NIT Number"
      matInput
      [matAutocomplete]="auto"
      [formControl]="autocompleteControl"
      #input
    />
    <mat-autocomplete
      (optionSelected)="onServiceSelected($event)"
      #auto="matAutocomplete"
      (valueChange)="onServiceSelected($event)"
    >
      @for (s of filteredOptions | async; track s[ticketNumberValue]) {
        <mat-option [value]="s[ticketNumberValue]" [disabled]="s.disabled">
          {{ s[this.ticketNumberValue] }} –
          @if (ticketType === 'service') {
            <span>{{ s[this.ticketNameValue][this.ticketNameSecondary] }}</span>
          } @else {
            <span>{{ s[this.ticketNameValue] }}</span>
          }
          @if (s.bandwidth) {
            <span> - {{ s.bandwidth }} </span>
          }
          @if (s.alias) {
            <span> - {{ s?.alias }}</span>
          }
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  @if (selectedServiceLocation) {
    <div class="display-static">
      <h3>Service location:</h3>
      <div class="icon-text">
        <div class="custom-icon location_dark"></div>
        {{ selectedServiceLocation }}
      </div>
    </div>
  }
}
